// extracted by mini-css-extract-plugin
export default {"bar":"Loader_bar__RPruX"};